import { err, ok, Result } from 'neverthrow';
import { FunctionTypingRule } from '../function-call';
import { ArityMismatch, InvalidFunctionCall } from '../../type-check-error';
import { implementsTy } from '../../implements';
import { Errs } from '../../type-checker';
import { Ty } from '../../../ty';
import { Intrinsics } from '../../../intrinsics';

export const dateFmtTypingRule: FunctionTypingRule = (op, args) => {
  const [target, fmt, ...rest] = args;
  if (!target || !fmt || rest.length > 0) {
    return err(
      new ArityMismatch({ name: op, expected: 2, attempted: args.length })
    );
  }

  if (!implementsTy({ subject: target, req: 'timestamp' })) {
    return err(
      new InvalidFunctionCall({
        op,
        recieved: args,
        allowed: [[[Ty.ty('timestamp'), Ty.nn('string')], Ty.nn('timestamp')]],
      })
    );
  }

  const enumRes = reqSingleVariantEnum(fmt);

  if (enumRes.isErr()) {
    return err(enumRes.error);
  }
  const parseRes = Intrinsics.dateFmt(new Date(), enumRes.value);

  if (parseRes.isErr()) {
    return err(
      new Errs.InvalidDateFmt({
        original: enumRes.value,
        msg: parseRes.error.msg,
      })
    );
  }

  return ok(
    Ty.shorthandToTy('string', { nullable: target.nullable || fmt.nullable })
  );
};

const reqSingleVariantEnum = (
  ty: Ty.ExtendedAttributeType
): Result<string, Errs.TypeCheckError> => {
  if (ty.ty.k !== 'enum' || ty.ty.t.length !== 1) {
    return err(
      new Errs.SingleVariantEnumRequired({
        got: ty,
      })
    );
  }

  return ok(ty.ty.t[0]!);
};
